import React from 'react';
import { useAppSelector } from '../../../state/hooks';
import getTranslationsByLangOrEng from '../../../utils/getTranslationsByLangOrLang';
import sample1 from '../../../assets/images/adHoc/sample-1.png';
import sample2 from '../../../assets/images/adHoc/sample-2.png';
import sample3 from '../../../assets/images/adHoc/sample-3.png';
import sample4 from '../../../assets/images/adHoc/sample-4.png';
import { AdHocSampleStyles } from './styles';

export const AdHocSample = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  return (
    <AdHocSampleStyles>
      <div className="container">
        <div className="texts">
          <h1>{getTranslationsByLangOrEng(interfaceLanguage, 'ad_hoc_7')}</h1>
        </div>
        <div className="cards">
          <div className="cards__item">
            <img src={sample1} alt="" />
            <div className="cards__item-text">
              <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'ad_hoc_8')}</h6>
              <p>{getTranslationsByLangOrEng(interfaceLanguage, 'ad_hoc_9')}</p>
            </div>
          </div>
          <div className="cards__item">
            <div className="cards__item-text">
              <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'ad_hoc_10')}</h6>
              <p>{getTranslationsByLangOrEng(interfaceLanguage, 'ad_hoc_11')}</p>
            </div>
            <img src={sample2} alt="" />
          </div>
          <div className="cards__item">
            <img src={sample3} alt="" />
            <div className="cards__item-text">
              <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'ad_hoc_12')}</h6>
              <p>{getTranslationsByLangOrEng(interfaceLanguage, 'ad_hoc_13')}</p>
            </div>
          </div>
          <div className="cards__item">
            <div className="cards__item-text">
              <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'ad_hoc_14')}</h6>
              <p>{getTranslationsByLangOrEng(interfaceLanguage, 'ad_hoc_15')}</p>
            </div>
            <img src={sample4} alt="" />
          </div>
        </div>
      </div>
    </AdHocSampleStyles>
  );
};
